import React from "react";
import "./ProjectEmailNotificationHistory.scss";
import Drawer from "@material-ui/core/Drawer";
import IconButton from "@material-ui/core/IconButton";
import Close from "@material-ui/icons/Close";
import Mail from "@material-ui/icons/Mail";
import Typography from "@material-ui/core/Typography";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import DOMPurify from "dompurify";
import { emailNotificationHistory } from "../../project/projectSelectors";
import { formatDateAndTime } from "../../../utilities";

const ProjectEmailNotificationHistory = ({ open, onClose, emailNotificationHistory }) => {
  if (!open) return null;
  return (
    <Drawer anchor="right" open={open} className="drawer-area-container" onClose={onClose}>
      <div className="drawer">
        <div className="drawer-header">
          <Typography variant="h5">Email Notification History</Typography>
          <IconButton className="icon-button" onClick={onClose}>
            <Close />
          </IconButton>
        </div>
        <div className="drawer-body">
          {emailNotificationHistory.length === 0 ? (
            <div className="no-notifications">
              <Mail className="mail-icon" />
              <Typography variant="body1">No email notifications have been sent yet.</Typography>
            </div>
          ) : (
            <div className="notification-items-container">
              {emailNotificationHistory.map((notification) => (
                <div className="notification-item" key={notification.id}>
                  <div>
                    <Typography variant="h6" style={{ fontWeight: 700 }}>{notification.subject}</Typography>
                    <Typography variant="caption">{formatDateAndTime(notification.created_at)}</Typography>
                  </div>
                  <div className="notification-item-row">
                    <Typography variant="subtitle1" className="email-title">By:</Typography>
                    <Typography variant="body1" >{notification.sender}</Typography>
                  </div>
                  <div className="notification-item-row">
                    <Typography variant="subtitle1" className="email-title">Recipient:</Typography>
                    <Typography variant="body1" >{notification.recipients}</Typography>
                  </div>
                  <div>
                    <Typography variant="subtitle1" className="email-title">Body:</Typography>
                    <Typography variant="body1" component="div" style={{padding: "0px 12px"}} dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(notification.message) }} />
                  </div>
                </div>
              ))}
            </div>
          )}
        </div>
      </div>
    </Drawer>
  );
}

ProjectEmailNotificationHistory.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  emailNotificationHistory: PropTypes.arrayOf(PropTypes.shape({
    recipients: PropTypes.string.isRequired,
    subject: PropTypes.string.isRequired,
    message: PropTypes.string.isRequired,
    sender: PropTypes.string.isRequired,
    created_at: PropTypes.string.isRequired,
    id: PropTypes.number.isRequired,
  })).isRequired,
};

const mapStateToProps = state => ({
  emailNotificationHistory: emailNotificationHistory(state),
});

const mapDispatchToProps = dispatch => ({
  // No dispatch actions needed for this component as of now
});

export default connect(mapStateToProps,
  mapDispatchToProps)(ProjectEmailNotificationHistory);